import PropTypes from 'prop-types';
import Link from 'redux-first-router-link';
import styled from 'styled-components';

import ArticleList from '~/components/ArticleList';
import { Button, Divider, H3 } from '~/components/Elements';
import { PagedContent } from '~/containers/Content';
import { colors } from '~/utils/css-mixins';

const Root = styled.div`
  margin-top: 40px;
`;

const StyledButton = styled(Button)`
  margin-top: 0.8rem;
`;

const LatestArticles = ({ type, slug, model, limit }) => {
  const articleTypes = {
    TV: { name: 'TV', plural: 'All TV' },
    NEWS: { name: 'Nyheter', plural: 'Alla nyheter' },
    CHRONICLE: { name: 'Krönikor', plural: 'Alla krönikor' },
  };

  const listActionType = `${type}_LIST`;
  const heading = articleTypes[type].name;
  const listText = articleTypes[type].plural;

  return (
    <Root>
      <H3 color={colors.bluedark} size="14">
        {slug
          ? type === 'TV'
            ? 'Mer TV'
            : `Fler ${heading.toLowerCase()}`
          : heading}
      </H3>
      <Divider marginTop="0.875rem" marginBottom="1.5rem" />
      <PagedContent
        model={model}
        offset={0}
        limit={limit}
        render={({ pageResults }) =>
          pageResults.length > 0 && (
            <ArticleList
              list={pageResults
                .filter(content => content.slug !== slug)
                .slice(0, 3)}
              articleType={type}
            />
          )
        }
      />
      <StyledButton
        as={Link}
        to={{
          type: listActionType,
        }}
        size="large"
      >
        {listText}
      </StyledButton>
    </Root>
  );
};

LatestArticles.propTypes = {
  type: PropTypes.oneOf(['NEWS', 'CHRONICLE', 'TV']).isRequired,
  slug: PropTypes.string,
  model: PropTypes.oneOf(['chronicleList', 'tvList', 'newsList']).isRequired,
  limit: PropTypes.number.isRequired,
};

export default LatestArticles;
